<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">&nbsp;</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
    <markdown class="variable-binding" [data]="md"></markdown>
</div>
    <div class="modal-footer">
    </div>
